import { combineReducers } from "redux";

import { LOGOUT, SELECT_WORKSPACE } from "../actions/types";

import items from "./items";
import ordersTable from "./ordersTable";
import dynamicFields from "./dynamicFields";
import error from "./error";
import calendar from "./calendar";
import analytics from "./analytics";
import analyticsv2 from "./analyticsv2";
import files from "./files";
import groupSettings from "./groupSettings";
import auth from "./auth";
import adminConsole from "./adminConsole";
import workspace from "./workspace";
import dataset from "./dataset";
import genericGroups from "./genericGroups";

// Check if we should use analytics v2 based on the URL query parameter
const queryParams = new URLSearchParams(window.location.search);
const useAnalyticsV2 = queryParams.get('analytics-v2') === 'true';
const analyticsReducer = useAnalyticsV2 ? analyticsv2 : analytics;

const appReducer = combineReducers({
  items,
  ordersTable,
  dynamicFields,
  error,
  calendar,
  analytics: analyticsReducer,
  files,
  groupSettings,
  auth,
  adminConsole,
  workspace,
  dataset,
  genericGroups
});

const rootReducer = (state, action) => {
  if (action.type === SELECT_WORKSPACE) {
    const { auth, workspace, adminConsole } = state;
    state = { auth, workspace, adminConsole };
  } else if (action.type === LOGOUT) {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
